import { SetStateAction, useEffect } from "react";
import { ModalWithButtons } from "./modal";
import { BlueButton } from "../button";
import { useTranslation } from "react-i18next";
import {
	NeutralColor,
	PrimaryColor,
	SemanticColor,
} from "node-library/dist/colors";
import { useState } from "react";
import { sendPOSTRequest } from "../../requestHelper/sendRequest";
import { useSnackbar } from "../toast/showToastMessage";
import { Severity } from "node-library/dist/constants";
import { RedErrorIcon } from "../toast/errorIcons";
import { Autocomplete, TextField } from "@mui/material";
import { FrontendUserInfo, OrganizationInfo } from "node-library/dist/portal";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { AlertIcon } from "../svgIcons";

interface Props {
	open: boolean;
	organization: OrganizationInfo;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	proceedAction: () => void;
	setUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>;
	gotoOrganizationDetailsPage: (organization: OrganizationInfo) => void;
	addUser: (
		organization: OrganizationInfo,
		organizationUser: FrontendUserInfo
	) => void;
}

export default function AddOrganizationUserModal(props: Props) {
	const { t: translation } = useTranslation();

	const [selectedUser, setSeletedUser] = useState<FrontendUserInfo>();
	const [organizationUserList, setOrganizationUserList] =
		useState<Array<FrontendUserInfo>>();

	const [selectedUserErrorMsg, setselectedUserErrorMsg] = useState<string>("");

	const { openSnackbar } = useSnackbar();

	const { open, addUser, organization } = props;

	async function getUserList() {
		try {
			const response = await sendPOSTRequest(
				"/organizations/get-verified-and-not-organized-username",
				{}
			);

			const organizationUsers: Array<FrontendUserInfo> =
				response?.data?.organizationUsers;
			setOrganizationUserList(organizationUsers);
		} catch (error: any) {
			console.error(error);
			openSnackbar(
				translation("SystemError"),
				Severity.ERROR,
				translation("SystemErrorMsg"),
				<RedErrorIcon />
			);
		}
	}

	useEffect(() => {
		open && getUserList();
	}, [open]);

	const handleaddUser = async () => {
		setselectedUserErrorMsg("");
		if (selectedUser === undefined) {
			setselectedUserErrorMsg(translation("selectUsertoAdd"));
			return;
		} else {
			try {
				await (selectedUser && addUser(organization, selectedUser));
				setSeletedUser(undefined);
				props.setOpen(false);
			} catch (err: any) {
				openSnackbar(
					translation("SystemError"),
					Severity.ERROR,
					translation("SystemErrorMsg"),
					<RedErrorIcon />
				);
			}
		}
	};

	const modal: React.ReactNode = (
		<ModalWithButtons
			modalWidth={500}
			headerText={translation("AddUsers")}
			open={props.open}
			setOpen={props.setOpen}
			buttons={[
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						width: "100%",
						margin: "0px 40px",
					}}
				>
					<BlueButton
						buttonClassName="add-organization-save-button"
						key="add-organization-save-button"
						id="add-organization-save-button"
						children={translation("Save")}
						size="flex"
						onClick={() => {
							handleaddUser();
						}}
					></BlueButton>
				</div>,
			]}
		>
			<div
				className="typography-caption"
				style={{
					color: NeutralColor.NEUTRAL_GREY_500,
					maxWidth: "80%",
					marginTop: "-30px",
					marginBottom: "40px",
				}}
			>
				{translation("AddOrganizationUserDescription")}
			</div>
			<div
				style={{
					marginLeft: "5px",
					marginRight: "5px",
					marginBottom: "40px",
					display: "grid",
					gap: "10px",
				}}
			>
				<div
					style={{
						marginLeft: "15px",
					}}
				>
					{translation("UserNameandClientName")}
				</div>
				<Autocomplete
					disablePortal
					id="organization-user-dropdown"
					options={organizationUserList || []}
					value={selectedUser}
					popupIcon={<KeyboardArrowDownIcon />} // Toggle icon based on open state
					onChange={(event, newValue) => {
						if (newValue !== null) {
							setSeletedUser(newValue);
						} else {
							setSeletedUser(undefined);
						}
						if (selectedUser) {
							setselectedUserErrorMsg("");
						}
					}}
					renderInput={(params) => (
						<TextField
							{...params}
							label=""
							sx={{
								"& .MuiOutlinedInput-root": {
									padding: "4px 9px", // Custom padding for input field

									"&:hover": {
										borderColor: PrimaryColor.PRIMARY_800, // Change border color on hover
									},
									//   '&.Mui-focused': {
									//     borderColor: 'red', // Change border color when focused
									//   },
								},
								"& .MuiOutlinedInput-root fieldset": {
									borderColor: NeutralColor.NEUTRAL_GREY_900, // Change border color
								},
							}}
						/>
					)}
					getOptionLabel={(option) => {
						return option
							? `${option.userName} - ${option.firstName} ${option.lastName}`
							: option;
					}}
					isOptionEqualToValue={(option, value) => option === value} // Comparison for selected value
				/>
				{selectedUserErrorMsg && selectedUserErrorMsg.length > 0 && (
					<div
						style={{
							display: "flex",
							gap: "5px",
							color: SemanticColor.ERROR,
							alignItems: "center",
						}}
					>
						<AlertIcon></AlertIcon>
						{selectedUserErrorMsg}
					</div>
				)}
			</div>
		</ModalWithButtons>
	);

	return modal;
}
